import { centerCrop, convertToPixelCrop, Crop, makeAspectCrop } from "react-image-crop"

export const MIN_CROP_SIZE = 32
export const MAX_OUTPUT_SIZE = 400

type Dimensions = {
  width: number
  height: number
}

type SourceImage = Dimensions & {
  naturalWidth: number
  naturalHeight: number
}

export const defaultCrop = (image: HTMLImageElement): Crop => {
  const { width, height } = image
  const percentCrop = centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      1,
      width,
      height
    ),
    width,
    height
  )
  return convertToPixelCrop(percentCrop, width, height)
}

export const isUsableCrop = (crop: Crop | undefined): crop is Crop => {
  return !!crop && crop.width > 0 && crop.height > 0
}

export const isLoadedImage = (image: SourceImage): boolean => {
  return image.width > 0 && image.height > 0 && image.naturalWidth > 0 && image.naturalHeight > 0
}

export const sourceRegion = (image: SourceImage, crop: Crop) => {
  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height
  return {
    x: crop.x * scaleX,
    y: crop.y * scaleY,
    width: crop.width * scaleX,
    height: crop.height * scaleY,
  }
}

export const outputDimensions = (source: Dimensions, maxSize: number): Dimensions => {
  const scale = Math.min(1, maxSize / Math.max(source.width, source.height))
  return {
    width: Math.max(1, Math.round(source.width * scale)),
    height: Math.max(1, Math.round(source.height * scale)),
  }
}

export const cropImage = (canvas: HTMLCanvasElement, image: HTMLImageElement, crop: Crop) => {
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('Could not get 2d context')
  }

  const source = sourceRegion(image, crop)
  const output = outputDimensions(source, MAX_OUTPUT_SIZE)

  canvas.width = output.width
  canvas.height = output.height

  ctx.drawImage(image, source.x, source.y, source.width, source.height, 0, 0, output.width, output.height)
}
